module.exports = __webpack_public_path__ + "img/logo-sm.ce21264f.svg";